import React from 'react'
import classnames from 'classnames'

import useHeader from '../../hooks/useHeader'

import styles from '../../styles/components/Header/HeaderToggle.module.css'

const HeaderToggle = props => {
  const header = useHeader()
  const toggleClassName = classnames(styles.toggle, {
    [styles.toggleFixed]: header.isFixed
  })

  return (
    <button onClick={header.onToggleClick} className={toggleClassName}>
      Menu
    </button>
  )
}

export default HeaderToggle
